<script setup lang="ts">
import axios from 'axios';
import Avatar from 'vue3-avatar';

import Evento from '@/evento/components/evento.component.vue';

const apiBaseUrl = import.meta.env.VITE_API_URL || '/api';

const eventos = await axios.get(`${apiBaseUrl}/eventos/-33.447915/-70.670447`);
let perfil;
let usuarioLogueado;
try {
  perfil = await axios.get(`${apiBaseUrl}/profile`);
  usuarioLogueado = true;
} catch (e: any) {
  usuarioLogueado = false;
}

function finalizarGenero() {
  switch (perfil?.data?.genero) {
    case 'M':
      return 'o';
    case 'F':
      return 'a';
    default:
      return 'e';
  }
}
function getTituloLista() {
  if (eventos.data.every(e => !e.registrado)) {
    return 'Eventos a los que te puedes registrar';
  }
  return 'Otros eventos a los que te puedes registrar';
}
</script>
<template>
  <section class="mx-auto max-w-6xl px-4 py-8">
    <header class="relative mb-8">
      <div v-if="usuarioLogueado">
        <div class="grid grid-cols-2">
          <div>
            <avatar
              :imageSrc="`${apiBaseUrl}/fotos/${perfil.data.foto}`"
              :name="`${perfil.data.nombre} ${perfil.data.apellido}`"
              :customAvatarStyle="{ height: '100px', width: '100px' }"
            />
          </div>
          <div class="items-end">
            <router-link
              to="/profile"
              data-testid="link-perfil"
              class="mb-1 inline-flex w-1 w-full items-center gap-2 rounded-md bg-teal-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-teal-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
            >
              Mi Perfil
            </router-link>
            <router-link
              to="/logout"
              data-testid="link-inicio-sesion"
              class="inline-flex w-full items-center gap-2 rounded-md bg-teal-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-teal-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
            >
              Cerrar Sesion
            </router-link>
          </div>
        </div>
        <div class="grid grid-cols-1">
          <div class="text-3xl font-bold text-gray-900" data-testid="mensaje-bienvenida">
            Bienvenid{{ finalizarGenero() }} {{ perfil?.data?.nombre }}
          </div>
        </div>
      </div>

      <div
        v-else
        data-testid="mensaje-bienvenida-sin-usuario"
        class="flex flex-col-reverse gap-2 md:flex md:flex-row md:items-start md:justify-between"
      >
        <div>
          <h1 class="text-3xl font-bold tracking-tight text-gray-900">Eventos cerca de ti</h1>
          <p class="mt-1 text-sm text-gray-500">Explora actividades y experiencias en tu zona.</p>
        </div>
        <router-link
          to="/login"
          data-testid="link-inicio-sesion"
          class="inline-flex items-center gap-2 self-end rounded-md bg-teal-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-teal-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 md:self-end"
        >
          Iniciar Sesion
        </router-link>
      </div>
    </header>
    <div v-if="eventos.data.some(e => e.registrado)">
      <h2
        class="text-2xl font-bold tracking-tight text-gray-900"
        data-testid="evento-registrado-titulo"
      >
        Te encuentras registrad{{ finalizarGenero() }} como asistente en el siguiente evento:
      </h2>
      <div class="py-4" v-for="evento in eventos.data.filter(e => e.registrado)" :key="evento.id">
        <evento data-testid="evento-registrado" :evento="evento" class="mb-4" />
      </div>
    </div>

    <h2
      class="pb-4 text-2xl font-bold tracking-tight text-gray-900"
      data-testid="lista-eventos-titulo"
      v-if="usuarioLogueado"
    >
      {{ getTituloLista() }}
    </h2>
    <div
      v-if="eventos?.data?.length"
      class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-10 xl:gap-12"
    >
      <evento
        :evento="evento"
        v-for="evento in eventos.data.filter(e => !e.registrado)"
        :key="evento.id"
        data-testid="evento"
      />
    </div>

    <div
      v-if="!eventos?.data?.length"
      class="rounded-lg border border-dashed border-gray-300 p-10 text-center"
    >
      <p class="text-gray-500">No hay eventos disponibles en este momento.</p>
    </div>
  </section>
</template>

<style scoped></style>
